module.exports = __webpack_public_path__ + "img/b_KalciyCS_right.ec13a3af.jpeg";